import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Fusion de classes utilitaires.
 *
 * `clsx` résout les conditions, `tailwind-merge` arbitre les conflits : sans
 * lui, `px-4` passé en propriété ne remplacerait pas le `px-3` du composant, les
 * deux se retrouveraient dans l'attribut et c'est l'ordre de la feuille — non
 * l'intention de l'appelant — qui trancherait.
 *
 * C'est l'utilitaire `cn` de shadcn/ui, repris tel quel : les composants de
 * `composants/ui` en dépendent, et s'en écarter les rendrait impossibles à
 * remettre à jour depuis l'amont.
 */
export function cn(...entrees: readonly ClassValue[]): string {
  return twMerge(clsx(entrees));
}
